import React from 'react';

export default function PreorderProductsStep({ products, selected, onChange }) {
  if (!products.length) return null;

  function toggle(p) {
    const exists = selected.find(x => x.product_id === p.id);
    if (exists) onChange(selected.filter(x => x.product_id !== p.id));
    else onChange([...selected, { product_id: p.id, qty: 1, price: p.price }]);
  }
  function setQty(p, qty) {
    onChange(selected.map(x => x.product_id === p.id ? { ...x, qty } : x));
  }
  return (
    <div className="border rounded-xl p-3">
      <div className="font-semibold mb-2">Pre-order items (optional)</div>
      <div className="grid sm:grid-cols-2 gap-2">
        {products.map(p => {
          const sel = selected.find(x => x.product_id === p.id);
          return (
            <div key={p.id} className="border rounded p-2 flex items-center justify-between">
              <div>
                <div className="text-sm">{p.name}</div>
                <div className="text-xs text-gray-600">€{Number(p.price).toFixed(2)}</div>
              </div>
              <div className="flex items-center gap-2">
                {sel && (
                  <input type="number" min={1} value={sel.qty} onChange={e => setQty(p, Number(e.target.value || 1))}
                    className="w-16 border rounded px-2 py-1 text-sm" />
                )}
                <button onClick={() => toggle(p)} className="text-sm rounded px-2 py-1 border">
                  {sel ? 'Remove' : 'Add'}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
